import { IbhFilterKeys } from '@hub/libs/constants';
import type { IbhFilterControl, IbhFilterValues } from '@hub/hooks/states/useIbhFilterValuesStore';
import { useTranslation } from 'next-i18next';
import { Checkbox } from '@hub/common/Checkbox/Checkbox';
import type { IbhDimensions } from '@hub/bearing-hub/common/dimensions/dimensions';

interface ElectricalPropertiesSectionProps {
  filterValues: IbhFilterValues;
  filterControl: IbhFilterControl;
  setFilterValue: (key: IbhFilterKeys, value: string | string[] | number | boolean | undefined | IbhDimensions) => void;
  isCollapsible?: boolean;
}

export const ElectricalPropertiesSection = ({
  setFilterValue,
  filterValues,
  filterControl,
  isCollapsible = false,
}: ElectricalPropertiesSectionProps) => {
  const { t } = useTranslation(['category/productFilter', 'common']);

  return (
    <Checkbox
      disabled={!!filterControl[IbhFilterKeys.ELECTRICALLY_CONDUCTIVE]}
      key={`filter_${isCollapsible ? 'collapsible_' : ''}${IbhFilterKeys.ELECTRICALLY_CONDUCTIVE}`}
      id={`filter_${isCollapsible ? 'collapsible_' : ''}${IbhFilterKeys.ELECTRICALLY_CONDUCTIVE}`}
      value={
        !!filterControl[IbhFilterKeys.ELECTRICALLY_CONDUCTIVE] === true
          ? false
          : !!(filterValues[IbhFilterKeys.ELECTRICALLY_CONDUCTIVE] as boolean | undefined)
      }
      onChange={newValue => {
        setFilterValue(IbhFilterKeys.ELECTRICALLY_CONDUCTIVE, newValue || undefined);
      }}
      label={t(`FILTERS.LABELS.ELECTRICALLY_CONDUCTIVE`, { ns: 'bearing-hub/bearingHub' })}
    />
  );
};
